import { useQuery } from '@tanstack/react-query';
import api from '../../api';
import { type Order } from '../../types/api/order/order';

type OrderQueryKey = ['orders', string];

export function usePollOrderQuery(orderId: string, shouldPoll: boolean, interval: number) {
  return useQuery<Order, Error, Order, OrderQueryKey>({
    queryKey: ['orders', orderId],
    queryFn: () => api.order.get(orderId),
    refetchInterval: shouldPoll && interval,
    enabled: Boolean(orderId),
  });
}
